import { css } from 'lit'

export default css`
    .option {
        display: flex;
        align-items: center;
        cursor: pointer;
        padding: 0.75rem 1rem;
        font-size: var(--zaptic-multi-select-font-size, 1.4rem);
    }
    .option:hover {
        background-color: var(--darkerCloudGrey);
    }
    .checkbox {
        display: inline-flex;
    }
    .title {
        font-weight: var(--font-weight-medium);
        color: var(--grey1);
    }
    .details {
        margin-left: 8px;
        color: var(--grey3);
    }
`
